import {useSelector} from "react-redux";

export default function () {
    const responseOptions = useSelector(state => state.responseOptions.responseOptions);
    const loadingResponseOptions = useSelector(state => state.responseOptions.loading);

    return { responseOptions, loadingResponseOptions };
}